import type { SelectField, TextField } from './shared'
import type Storyblok from '~/types/vendors/storyblok'
import { normalizeRichtext } from '~/utils/storyblok/richtext'

export interface SubscriberBlockResponse {
  block_identifier: string
  segment_id: string
  title: string
  cta_label: string
  description?: string
  form: (TextField | SelectField)[]
  background_color?: string
  legal: Storyblok.Richtext
  success_message: Storyblok.Richtext
  error_message: Storyblok.Richtext
}

export interface SubscriberBlock {
  identifier: string
  segmentId: string
  component: 'subscriber-block'
  title: string
  description: string
  ctaLabel: string
  form: (TextField | SelectField)[]
  backgroundColor: string
  legal: Storyblok.Richtext
  successMessage: Storyblok.Richtext
  errorMessage: Storyblok.Richtext
}

export function normalizeSubscriberBlock(subscriberBlock?: SubscriberBlockResponse): SubscriberBlock {
  const { legal, success_message, error_message } = subscriberBlock ?? {}
  return {
    identifier: subscriberBlock?.block_identifier || '',
    segmentId: subscriberBlock?.segment_id || '',
    component: 'subscriber-block',
    legal: normalizeRichtext(legal),
    title: subscriberBlock?.title?.trim() || '',
    ctaLabel: subscriberBlock?.cta_label?.trim() || '',
    form: subscriberBlock?.form || [],
    backgroundColor: subscriberBlock?.background_color || 'white',
    description: subscriberBlock?.description?.trim() || '',
    successMessage: normalizeRichtext(success_message),
    errorMessage: normalizeRichtext(error_message),
  }
}
